import { render, staticRenderFns } from "./SelectableCategorie.vue?vue&type=template&id=80de9f44"
import script from "./SelectableCategorie.vue?vue&type=script&lang=js"
export * from "./SelectableCategorie.vue?vue&type=script&lang=js"
import style0 from "./SelectableCategorie.vue?vue&type=style&index=0&id=80de9f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports